import * as Sentry from "@sentry/vue";

// Records a non-fatal client-state divergence and returns false so callers can `return reportMiss(...)`.
export const reportMiss = (
  category: string,
  action: string,
  reason: string,
  payload: unknown
): false => {
  Sentry.addBreadcrumb({
    category,
    level: "warning",
    message: `${action}: ${reason}`,
    data: { payload },
  });
  return false;
};

export const getUserAgent = (event?: Sentry.Event): string => {
  const headers = event?.request?.headers;

  if (!headers) {
    return window.navigator.userAgent;
  }

  // Handle headers as object format: { "User-Agent": "..." }
  if (typeof headers === "object" && !Array.isArray(headers)) {
    return headers["User-Agent"] ?? window.navigator.userAgent;
  }

  // Handle headers as array of arrays format: [["User-Agent", "..."]]
  if (Array.isArray(headers)) {
    const userAgentHeader = headers.find(
      ([key]) => key.toLowerCase() === "user-agent"
    );
    return userAgentHeader?.[1] ?? window.navigator.userAgent;
  }

  return window.navigator.userAgent;
};

export const containsAnyPattern = (
  err: unknown,
  event: Sentry.Event | undefined,
  patterns: string[]
): boolean => {
  const errorString =
    err instanceof Error
      ? err.message.toLowerCase()
      : String(err).toLowerCase();

  const eventMessage = (event?.message ?? "").toLowerCase();
  const exceptionValues = event?.exception?.values ?? [];
  const exceptionStrings = exceptionValues.map(
    (v) => v.value?.toLowerCase() ?? ""
  );

  return patterns.some((pattern) => {
    const p = pattern.toLowerCase().trim();
    return (
      errorString.includes(p) ||
      eventMessage.includes(p) ||
      exceptionStrings.some((val) => val.includes(p))
    );
  });
};
